import React from 'react';
import './ContactLensParams.scss';
import { useSelector } from 'react-redux';
import ContactLensParamsDropdown from './ContactLensParamsDropdown/ContactLensParamsDropdown';
import OdInfoCircleYellowIcon from '../../../../../../static/assets/svg/od-info-circle-yellow-icon.svg';

const ContactLensParams = props => {
  const { packaging, powers, selectContactLensPowersCallback } = props;

  const dataLocale = useSelector(state => state.locale);

  const {
    SELECT_POWER,
    CONTACT_LENS_POWER_DISCLAIMER,
    INFO,
    CONTACT_LENS_PACKAGING_1,
    CONTACT_LENS_PACKAGING_2,
    CONTACT_LENS_POWER_1,
    CONTACT_LENS_POWER_2,
  } = dataLocale;

  if (!powers?.length) return null;

  return (
    <>
      <div className="contact-lens-params">
        <hr className="contact-lens-params__delimiter" />
        <div className="contact-lens-params__title od-font-reg">{SELECT_POWER}</div>
        <div className="contact-lens-params-grid">
          <div />
          <div className="contact-lens-params-grid__column-title od-font-reg">OS (Left eye)</div>
          <div className="contact-lens-params-grid__column-title od-font-reg">OD (Right eye)</div>
          {powers.map(({ type, label, powerDataList }) => (
            <React.Fragment key={type}>
              <div className="contact-lens-params-grid__row-title od-font-reg">
                {label}{' '}
                <div className="contact-lens-params-grid__tooltip">
                  <img
                    alt={INFO}
                    className="contact-lens-params-grid__tooltip-icon"
                    src={OdInfoCircleYellowIcon}
                  />
                  <div className="contact-lens-params-grid__tooltip-text od-font-light">
                    {type === 'boxes' ? (
                      `${CONTACT_LENS_PACKAGING_1} ${packaging} ${CONTACT_LENS_PACKAGING_2}`
                    ) : (
                      <>
                        {CONTACT_LENS_POWER_1}
                        <br />
                        {CONTACT_LENS_POWER_2}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <ContactLensParamsDropdown
                options={powerDataList?.[0] || []}
                selectOptionCallback={value => selectContactLensPowersCallback('left', type, value)}
                type={type}
              />
              <ContactLensParamsDropdown
                options={powerDataList?.[0] || []}
                selectOptionCallback={value =>
                  selectContactLensPowersCallback('right', type, value)
                }
                type={type}
              />
            </React.Fragment>
          ))}
        </div>
        <div className="contact-lens-params__disclaimer od-font-reg">
          {CONTACT_LENS_POWER_DISCLAIMER}
        </div>
      </div>
    </>
  );
};

export default ContactLensParams;
